import {createFileRoute, redirect} from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_admin/_legacy/instagram-media-manager")({
  beforeLoad: () => {
    throw redirect({to: "/admins/instagram-media-manager", replace: true});
  },
});
